import styled from 'foundations-theming/utils';
import { useCallback, useEffect, useState } from 'react';
import emptyFunction from 'react-utils/emptyFunction';
const FADE_DURATION = 250;
const HIGHLIGHT_DURATION = 500;
export const HighlightConditionBoxesWrapper = styled.div.withConfig({
  displayName: "useHighlightConditionBoxes__HighlightConditionBoxesWrapper",
  componentId: "rdi0xp-0"
})(["", "{transition:border-color ", "ms,box-shadow ", "ms;}", " .condition-box{transition:background-color ", "ms,box-shadow ", "ms;}", ""], ({
  targetSelector
}) => targetSelector && `${targetSelector}`, FADE_DURATION, FADE_DURATION, ({
  targetSelector
}) => targetSelector && `${targetSelector}`, FADE_DURATION, FADE_DURATION, ({
  isHighlighted,
  targetSelector,
  isEditor,
  theme
}) => isHighlighted && `${targetSelector && `${targetSelector}`} {
    border-color: ${theme.color['fill-info-default']};
    box-shadow: ${theme.boxShadow['100']};
  }

  ${isEditor && `.condition-box {
    background-color: ${theme.color['fill-accent-blue-subtle']};
  }`}`);
export const useHighlightConditionBoxes = (onHighlightFinish = emptyFunction) => {
  const [isHighlighted, setIsHighlighted] = useState(false);
  const highlightConditionBoxes = useCallback(() => {
    setIsHighlighted(true);
  }, []);
  const unhighlightConditionBoxes = useCallback(() => {
    setIsHighlighted(false);
  }, []);
  useEffect(() => {
    let handler;
    if (isHighlighted) {
      handler = setTimeout(() => {
        setIsHighlighted(false);
        onHighlightFinish();
      }, FADE_DURATION + HIGHLIGHT_DURATION);
    }
    return () => {
      clearTimeout(handler);
    };
  }, [isHighlighted, onHighlightFinish]);
  return {
    isHighlighted,
    highlightConditionBoxes,
    unhighlightConditionBoxes
  };
};